import React, { useState } from "react"

import { usePet } from "../../modules"

import Confirm from "../reusable/confirm"
import Modal from "../reusable/modal"

const NewWard = ({ toggle, name: nm, visible, onPerform }) => {
    const [name, setName] = useState(nm)
    const [price, setPrice] = useState(0)
    const [capacity, setCapacity] = useState(1)

    const [, newWard] = usePet('newWard', {
        name,
        price,
        capacity
    }, { notify: true, callback:({ data }, notif, ops) => {
        notif('Ward has been created', ops('success'))
        onPerform(data)
        setTimeout(toggle, 300)
    }, manual: true, load: { msg: 'Creating new ward...' } })

    return (
        <Modal
            w={ 400 }
            title="Create New Ward"
            toggle={toggle}
            visible={visible}>
            <div className="w-full px-3 mb-6 md:mb-0">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                    Name
                </label>
                <input
                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                    id="grid-name"
                    type="text"
                    value={ name }
                    onChange={ e => setName(e.target.value)}
                    placeholder="Ksh. 4500 per day" />
            </div>
            <div className="w-full px-3 mb-6 md:mb-0">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                    Bed Charges
                </label>
                <input
                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                    id="grid-bed"
                    type="number"
                    value={ price }
                    onChange={ e => setPrice(e.target.value)}
                    placeholder="Ksh. 4500 per day" />
            </div>
            <div className="w-full px-3 mb-6 md:mb-0">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                    Bed Capacity
                </label>
                <input
                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                    id="grid-beds"
                    type="number"
                    value={ capacity }
                    onChange={ e => setCapacity(e.target.value)}
                    placeholder="40 Beds" />
            </div>
            <div className="flex justify-end">
                <button onClick={ () => 
                    Confirm({
                        title: `Create Ward Named "${name}"?`,
                        message: 'Please confirm before performing this action',
                        okText: 'Create Ward',
                        onOk: newWard
                    }) } type="submit" className="text-white hisani-btn-green-light font-medium rounded-lg text-sm px-5 py-2.5 text-center">Create Ward</button>
            </div>
        </Modal>
    )
}

export default NewWard